import { axiosClient } from '../axios';

export async function getAssignedAssessments(bundleKey) {
  return axiosClient.get('formbundle', {
    params: {
      bundleKey,
    },
  });
}
